import { GREY, GREEN_6, AMBER_6 } from '../components/FlyingV2/styles/constants';

const THREE_MINUTES = 3 * 60 * 1000;
export const FIFTEEN_MINUTES = 15 * 60 * 1000;

export const getStatusColourFromPointTime = (lastPointTime: number | undefined): string => {
  const now = Date.now();
  if (!lastPointTime) {
    return GREY;
  }
  const timeElapsed = now - lastPointTime;

  if (timeElapsed <= THREE_MINUTES) {
    return GREEN_6;
  } else if (timeElapsed <= FIFTEEN_MINUTES) {
    return AMBER_6;
  } else {
    return GREY;
  }
};
